"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCompanySetting = exports.isCompanySetting = void 0;
const __1 = require("..");
const WORKING_HOURS_VALUE_REGEX = /^([0-1]\d|2[0-3]):([0-5]\d)$/;
function isCompanySetting(object) {
    return checkCompanySetting(object).fulfilled;
}
exports.isCompanySetting = isCompanySetting;
function checkCompanySetting(object, options = { ignoreSuperfluousObjectProperties: true }) {
    const result = (0, __1.check)(object, (0, __1.hasString)("companyId"), (0, __1.hasArray)("status", (0, __1.isRecord)((0, __1.hasString)("id").nonEmpty(), (0, __1.hasString)("name").nonEmpty(), (0, __1.hasString)("description").optional())), (0, __1.hasObject)("workingHours", (0, __1.hasString)("start").matchRegex(WORKING_HOURS_VALUE_REGEX), (0, __1.hasString)("end").matchRegex(WORKING_HOURS_VALUE_REGEX)).optional(), (0, __1.hasArray)("workingDays", (0, __1.isRecord)((0, __1.hasBoolean)("enabled"))).optional(), (0, __1.hasArray)("workTypes", (0, __1.isRecord)((0, __1.hasString)("id"), (0, __1.hasString)("name"), (0, __1.hasBoolean)("deleted"), (0, __1.hasString)("icon").optional())).optional()).withOptions(options).explain();
    if (object.workingDays && object.workingDays.length !== 7) {
        result.fulfilled = false;
        result.reasons = result.reasons || [];
        result.reasons.push({
            path: "$.workingDays.length",
            explanation: "has to be exact 7 (Mo-Su)",
            value: object.resourceId,
        });
    }
    return result;
}
exports.checkCompanySetting = checkCompanySetting;
//# sourceMappingURL=CompanySetting.js.map